import { Injectable } from "@angular/core";
import { GenericService, ErrorConfig } from "./generic.service";
import { environment } from "src/environments/environment";
import { ISAPI } from "is-lib";
import { ServerResponse } from "../models/ServerResponse";
import { Observable } from "rxjs";
import { UsersService } from "./users.service";

@Injectable({
    providedIn: 'root'
})

export class EnergySupplyService{
    constructor(private _genericService: GenericService, private _userService: UsersService) { }
    
    getContractedPriceTypes(errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any[]>> {
        return this._genericService.get(`${environment.apiUrl}EnergySupplies/${this._userService.userCountryCode}/ContractedPriceTypes`, true, undefined, undefined, errorConfig);
    }

}